module.exports = __webpack_public_path__ + "media/images/users_voice06-9875971b81867bafacd726d381f85ed6.jpg";